import { useErrorStore } from '@/stores/error'
import type { RouteLocationNormalized } from 'vue-router'
import { getFieldMessage } from '@/utils/message'

export function errorGuard(to: RouteLocationNormalized) {
  const errorStore = useErrorStore()

  // エラーが存在する場合、ErrorPageに遷移
  if (errorStore.hasError && to.name !== 'ErrorPage') {
    return { name: 'ErrorPage' }
  }

  // 未定義ルートならエラーをセットして ErrorPage に遷移
  if (to.matched.length === 0) {
    errorStore.setError(getFieldMessage('systemerror913_1'), getFieldMessage('systemerror913_2'))
    return { name: 'ErrorPage' }
  }

  return null
}
